module.exports = __webpack_public_path__ + "assets/img/blatto.e6f9e2e3.png";